var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("path", {
      attrs: {
        d: "M15.3997 4.134C14.456 1.718 12.0515 0 9.23489 0C6.41827 0 4.01374 1.716 3.07006 4.132C1.30426 4.582 0 6.142 0 8C0 10.21 1.84409 12 4.11882 12H14.3427C16.6174 12 18.4615 10.21 18.4615 8C18.4615 6.146 17.1614 4.586 15.3997 4.134Z",
        fill: _vm.color1,
      },
    }),
    _c("path", {
      attrs: {
        d: "M6.59811 6.23456L7.89713 8.30374L10.872 3.09241",
        stroke: "#5481A6",
        "stroke-width": "2",
        "stroke-linecap": "round",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }